import React from 'react';
import './service-step-view.scss';
import ServiceHandler from '../../../components/sections/osb-v3/service-step/service-handler/service-handler';

export function ServiceStepView() {
    return (
        <div className="osb-v3-service-step-view-container">
            <ServiceHandler />
        </div>
    );
}
